import Freeplay from './freeplay';
import WeeklyRakeback from './weekly-rakeback';
import RandomBoost from './random-boost';
import MonthlyRakeback from './monthly-rakeback';
import BirthdayBonus from './birthday-bonus';
import DepositAssist from './deposit-assist';

export default () => {

    return (
        <div className="vip-20-bonuses">
            <div className="vip-20-title">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_3499_1038)">
                        <path d="M28.458 2.2666C23.596 2.2666 17.0771 5.60087 12.6979 11.3333H9.06666C6.44412 11.3333 4.94132 13.2917 3.90546 15.3611L2.51599 18.1333H9.06666L12.4667 21.5333L15.8667 24.9333V31.4817L18.6388 30.0945C20.7083 29.0609 22.6667 27.5558 22.6667 24.9333V21.3021C28.3991 16.9229 31.7333 10.4017 31.7333 5.54193V2.2666H28.458ZM22.6667 9.0666C23.2678 9.0666 23.8444 9.30541 24.2694 9.73049C24.6945 10.1556 24.9333 10.7321 24.9333 11.3333C24.9333 11.9344 24.6945 12.511 24.2694 12.936C23.8444 13.3611 23.2678 13.5999 22.6667 13.5999C22.0655 13.5999 21.489 13.3611 21.0639 12.936C20.6388 12.511 20.4 11.9344 20.4 11.3333C20.4 10.7321 20.6388 10.1556 21.0639 9.73049C21.489 9.30541 22.0655 9.0666 22.6667 9.0666ZM7.93332 22.6666L6.79999 23.7999C5.16346 25.4365 4.53332 29.4666 4.53332 29.4666C4.53332 29.4666 8.38212 29.0178 10.2 27.1999L11.3333 26.0666L7.93332 22.6666Z" fill="#F5691A"/>
                    </g>
                    <defs>
                        <filter id="filter0_d_3499_1038" x="2.51599" y="2.2666" width="29.2173" height="29.2148" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feMorphology radius="15" operator="erode" in="SourceAlpha" result="effect1_dropShadow_3499_1038"/>
                            <feOffset/>
                            <feGaussianBlur stdDeviation="7.5"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0.972549 0 0 0 0 0.580392 0 0 0 0 0.207843 0 0 0 0.5 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3499_1038"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3499_1038" result="shape"/>
                        </filter>
                    </defs>
                </svg>

                VIP Benefits
            </div>

            <div className="vip-20-bonuses-list">
                <Freeplay />
                <WeeklyRakeback />
                <RandomBoost />
                <MonthlyRakeback />
                <BirthdayBonus />
                <DepositAssist />
            </div>
        </div>
    )
}